export default __webpack_public_path__ + "static/media/loader.05ec90be.gif";